<template>
    <div class="checkout">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <shadow-box class="box-checkin">
                        <div class="row ">
                            <div class="col-md-7">
                                <p class="text-big">Tạm biệt <br> Nhớ chấm công nhé</p>
                                <p class="hour">
                                    {{ timenow }}
                                </p>
                            </div>
                            <div class="col-md-5">
                                <qrcode-vue :value="qr" :size="200" :className="'qr'" ></qrcode-vue>
                            </div>
                        </div>
                    </shadow-box>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ShadowBox from '@/components/ShadowBox'
import QrcodeVue from 'qrcode.vue';
import moment from 'moment'
import {getQrApi} from '@/api/api'
export default {
    name: 'Checkout',
    components: {ShadowBox, QrcodeVue},
    data() {
        return {
            timenow: '',
            qr:''
        }
    },
    methods: {
        getQrCode(){
            getQrApi().done((rs)=>{
                this.qr = rs.data.qr; 
            });

        },
        time() {
        var self = this
        this.timenow = moment().format('HH:mm:ss')

        setInterval(()=>{
            var self = this
            this.timenow = moment().format('HH:mm:ss')
        }, 1000)},
    },
    mounted: function() {
        var self = this;
        this.time()
        var channel = this.$pusher.subscribe('dashboard');
        channel.bind('qr-check', ( log ) => {
            self.getQrCode();
            console.log(log);
            if (log.type == 'checkin') {
              this.$awn.success("Chúc " + log.user.fullname + ' có một ngày làm việc hiệu quả');
            } else {
              this.$awn.success("Chào tạm biệt " + log.user.fullname );
            }
        });
    },
    created(){
        this.getQrCode();
        
    }
}
</script>
<style>
.box-checkin{
    padding: 3em;
    margin-top:40%;
}
.checkout{
    height: calc(100vh);
    background: url('../assets/afternoon.png')
}
.text-big{
    font-size: 3em;
    text-transform: uppercase;
    font-weight: bold;
}
.hour{
    font-size: 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/Checkout.vue